var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-tag",class:[`u-size-${_vm.size}`, `u-mode-${_vm.mode}-error`]},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }